import { ChatDotRound, StarFilled, Document } from '@element-plus/icons-vue';
import { QQ_WJ_LINK } from '@/config/config';
export default {
  components: {
    ChatDotRound,
    StarFilled,
    Document
  },
  name: 'TooltipComp',
  data() {
    return {
      QQ_WJ_LINK
    };
  }
};